import styled from "styled-components";

export const TechnicalCardStyled = styled.div`
width: 32%;
max-height: 21.875rem;
/* height: 100%; */
min-height: 21.875rem;
padding: 3.75rem;
background: #fff;
color: #000;
margin-bottom: 20px;

& span {
	height: 5px;
	width: 1.875rem;
	background-color: rgb(7, 66, 117);
	display: inline-block;
	margin: 1.25rem 0rem;
}

@media(max-width:1439px){
	padding: 2rem;
}

@media(max-width:1085px){
width: 100%;
max-height: fit-content;
min-height: auto;
	padding: 1rem;
}
`